import React from 'react';
import { Maximize2, Minimize2 } from 'lucide-react';
import { Button } from '../../../components/ui';

/** Takes a chart to the whole screen and back; the word shows from a tablet up */
export const FullscreenButton: React.FC<{
  active: boolean;
  onToggle: () => void;
  className?: string;
}> = ({ active, onToggle, className = '' }) => {
  const label = active ? 'Exit full screen' : 'Full screen';
  const Icon = active ? Minimize2 : Maximize2;
  return (
    <Button
      size="sm"
      variant={active ? 'dark' : 'secondary'}
      onClick={onToggle}
      aria-label={label}
      aria-pressed={active}
      title={active ? 'Exit full screen (Esc)' : 'Full screen'}
      className={`flex-shrink-0 ${className}`}
    >
      <Icon className="h-3.5 w-3.5" strokeWidth={1.9} />
      <span className="hidden sm:inline">{label}</span>
    </Button>
  );
};
